/* eslint-disable react/jsx-max-depth */
import { ReactElement, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DecodedValueMap, QueryParamConfigMap } from 'use-query-params';
import KeywordSearch from '../LegislativeTracking/SearchFilters/KeywordSearch';

type PersonStaffSearchFiltersProps = {
  query: DecodedValueMap<QueryParamConfigMap>;
  resetScroll: () => void;
  setQuery: (arg: any) => void;
  setSearching: (arg: boolean) => void;
};

const PersonStaffSearchFilters = (
  props: PersonStaffSearchFiltersProps,
): ReactElement => {
  const { query, resetScroll, setQuery, setSearching } = props;
  const { t } = useTranslation();

  const [searchChanged, setSearchChanged] = useState(false);
  const [keywords, setKeywords] = useState<string>(query.keywords);

  useEffect(() => {
    setKeywords(query.keywords);
  }, [query]);

  const handleSearch = (): void => {
    setSearching(true);
    setQuery({
      keywords: keywords,
      page: 1,
    });
    resetScroll();
    setSearchChanged(false);
  };

  return (
    <div className="filters-container">
      <div className="row">
        <div className="col-lg default-search-filters">
          <KeywordSearch
            hasSearchChanged={searchChanged}
            keywords={keywords}
            search={handleSearch}
            setKeywords={setKeywords}
            setSearchChanged={setSearchChanged}
          />
        </div>
        <div className="d-inline-flex col-3 default-search-buttons">
          <button
            className="btn btn-sm btn-outline-secondary float-right btn-teal"
            disabled={!searchChanged}
            id="staffer-data-search-button"
            onClick={handleSearch}
            type="submit"
          >
            {t('buttons.search.submitButtonText')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PersonStaffSearchFilters;
